import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartOptions } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface ChartData {
  type: string;
  charts: Array<{
    id: string;
    type: string;
    title: string;
    data: {
      labels: string[];
      datasets: Array<{
        label: string;
        data: number[];
        percentages?: number[];
        backgroundColor: string | string[];
      }>;
    };
    options: any;
  }>;
}

interface ChartRendererProps {
  chartData: ChartData;
}

const ChartRenderer: React.FC<ChartRendererProps> = ({ chartData }) => {
  if (!chartData || !chartData.charts) return null;

  return (
    <div className="chart-container" style={{ marginTop: '20px', marginBottom: '20px', background: 'white', padding: '20px', borderRadius: '8px' }}>
      {chartData.charts.map((chart) => {
        const options: ChartOptions<'bar'> = {
          indexAxis: chart.options?.indexAxis || 'x',
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: chart.options?.plugins?.legend?.display ?? true,
              position: chart.options?.plugins?.legend?.position || 'top',
              labels: {
                boxWidth: chart.options?.plugins?.legend?.labels?.boxWidth || 40,
                padding: chart.options?.plugins?.legend?.labels?.padding || 15,
              },
            },
            title: {
              display: true,
              text: chart.title,
              font: { size: 16, weight: 'bold' },
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const dataset = chart.data.datasets[context.datasetIndex];
                  const value = context.parsed.x || context.parsed.y || 0;
                  const percentage = dataset.percentages?.[context.dataIndex];
                  
                  if (percentage !== undefined) {
                    return `${dataset.label}: $${value.toLocaleString()}/year (${percentage}%)`;
                  }
                  return `${dataset.label}: $${value.toLocaleString()}/year`;
                },
              },
            },
          },
          scales: {
            x: {
              stacked: chart.options?.scales?.x?.stacked || false,
              title: {
                display: chart.options?.scales?.x?.title?.display || false,
                text: chart.options?.scales?.x?.title?.text || '',
              },
            },
            y: {
              stacked: chart.options?.scales?.y?.stacked || false,
              title: {
                display: chart.options?.scales?.y?.title?.display || false,
                text: chart.options?.scales?.y?.title?.text || '',
              },
            },
          },
        };

        return (
          <div key={chart.id} style={{ marginBottom: '30px', height: '400px' }}>
            <Bar data={chart.data} options={options} />
          </div>
        );
      })}
    </div>
  );
};

export default ChartRenderer;
